module.exports = __webpack_public_path__ + "images/4a3df38fcddc1eaece6cbe34f65baf60highway.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/highway.png
// module id = piKe
// module chunks = 0